var React = require('react');

function DatePickerChevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.293.293a1 1 0 011.497 1.32l-.083.094L2.415 7l5.292 5.293a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.32.083l-.094-.083-6-6a1 1 0 01-.083-1.32l.083-.094 6-6z","fill":"#CCC","fillRule":"nonzero"}));
}

DatePickerChevron.defaultProps = {"viewBox":"0 0 8 14"};

module.exports = DatePickerChevron;

DatePickerChevron.default = DatePickerChevron;
